export function convertBoostrapColorToACssVar(color: BootstrapColors) {
  return `--bs-${color}`;
}

export type BootstrapColors =
  | 'primary'
  | 'secondary'
  | 'danger'
  | 'warning'
  | 'success'
  | 'purple';
